import getWeekDay from '~/utilities/date/getWeekDay';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';
import PickupAndDeliveryOption from '../common/PickupAndDeliveryOption';
import TagIds from '../common/tagIds';

const DELIVERY_DAYS_TO_SKIP = 4;
const dateOfDelivery = new Date();
dateOfDelivery.setDate(dateOfDelivery.getDate() + DELIVERY_DAYS_TO_SKIP);

const affordableCars = [
  {
    id: 'Cars under',
    copy: 'Cars Under $20,000',
    iconName: 'PriceDrop',
    link: generateSearchLinkFilter({
      filters: { price: { min: 7999, max: 20000 } }
    }),
    analyticEventDescription: 'Cars Under 20k'
  },
  {
    id: 'Great deals',
    copy: 'Shop Great Deals',
    iconName: 'GreatDeals',
    link: generateSearchLinkFilter({
      filters: { tagIds: [String(TagIds.GreatDeals)] }
    }),
    analyticEventDescription: 'Shop Great Deals'
  },
  {
    id: 'Four-day delivery',
    copy: `Delivery by ${getWeekDay(dateOfDelivery)}`,
    iconName: 'Delivery',
    link: generateSearchLinkFilter({
      filters: {
        earliestDayToDeliveryOrPickup: {
          days: 4,
          pickupAndDeliveryOption: PickupAndDeliveryOption.PickupAndDelivery
        }
      }
    }),
    analyticEventDescription: 'Delivery by',
    additionalCssClass: 'hauler-icon'
  },
  {
    id: 'Shop fuel efficient',
    copy: 'Shop Fuel Efficient',
    iconName: 'GasSavings',
    link: generateSearchLinkFilter({
      filters: { mpg: { min: 30, max: 150 } }
    }),
    analyticEventDescription: 'Shop Fuel Efficient'
  },
  {
    id: 'EV tax credit eligible',
    copy: 'EV Tax Credit Eligible',
    iconName: 'EVPlugSavings',
    link: generateSearchLinkFilter({
      filters: { tagIds: [String(TagIds.EvTaxCreditMayBeEligible)] }
    }),
    analyticEventDescription: 'EV Tax Credit Eligible'
  }
];

export default affordableCars;
